import React from 'react';
import Hero from '../components/Hero';
import LogoBar from '../components/LogoBar';
import WhyEmbrace from '../components/WhyEmbrace';
import Stats from '../components/Stats';
import Services from '../components/Services';
import VideoSection from '../components/VideoSection';
import Team from '../components/Team';
import Approach from '../components/Approach';
import Location from '../components/Location';
import Contact from '../components/Contact';

const Home = ({ openModal, handleSuccess }) => {
  return (
    <>
      <Hero openModal={openModal} />
      <LogoBar />
      <WhyEmbrace openModal={openModal} />
      <Stats />
      <Services openModal={openModal} />
      <VideoSection />
      <Team />
      <Approach />
      <Location />
      <Contact onSuccess={handleSuccess} />
    </>
  );
};

export default Home;
